// firebaseConfig.jsx
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyAFhK0YwSCiAPMAB1GhhSDYZS3B2r4fyP4",
  authDomain: "tayyab-3rd-client.firebaseapp.com",
  databaseURL: "https://tayyab-3rd-client-default-rtdb.firebaseio.com",
  projectId: "tayyab-3rd-client",
  storageBucket: "tayyab-3rd-client.firebasestorage.app",
  messagingSenderId: "992249323186",
  appId: "1:992249323186:web:d54f81ca0e0254c82db3ab"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getDatabase(app);
const auth = getAuth(app);
const storage = getStorage(app); // Initialize Firebase storage

export { db, auth, storage };
